import { render, staticRenderFns } from "./selectionPropertys.vue?vue&type=template&id=3bfa129e&scoped=true&"
import script from "./selectionPropertys.vue?vue&type=script&lang=js&"
export * from "./selectionPropertys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfa129e",
  null
  
)

export default component.exports